<template>
  <el-row class="cover_pre">
    <!--封面 +封面简介-->
    <el-col :span="24" class="cover">
      <el-col>
        <el-image :src="url" fit="scale-downx"></el-image>
      </el-col>
      <el-col class="introduction_detail">
        <div class="introduction_pre">{{ $t('home.journalTitle') }}</div>
        <br />
        <div class="introduction_pre">{{ $t('home.established') }}</div>
        <br />
<!--        <div>-->
<!--          <span class="introduction_pre">国际刊号:lSSN 2186-3288</span-->
<!--          >&nbsp;<span class="introduction_back"></span>-->
<!--        </div>-->
<!--        <br />-->
<!--        <div>-->
<!--          <span class="introduction_pre">征订刊号:世图BWT03</span>-->
<!--          <span class="introduction_back"></span>-->
<!--        </div>-->
<!--        <br />-->
<!--        <div>-->
<!--          <span class="introduction_pre">征订电话：13520794499</span>&nbsp;<span-->
<!--            class="introduction_back"-->
<!--          ></span>-->
<!--        </div>-->
<!--        <br />-->
<!--        <div>-->
<!--          <span class="introduction_pre">征订邮箱：qkb2@wpcbj.com.cn</span-->
<!--          >&nbsp;<span class="introduction_back"></span>-->
<!--        </div>-->
      </el-col>
    </el-col>
    <!--问与答-->
    <el-col :span="24" class="q_and_a_pre">
      <div class="q_and_a">{{ $t('home.qa') }}</div>
      <el-row class="q_and_a_detail">
        <el-col>
          <ul class="exceed">
            <li
              v-for="(item, index) in comments"
              :key="index"
              class="infinite-list-item space author-title reply-father"
              @click="qAndAClick(item)"
            >
              <el-row style="cursor: pointer"
                ><el-col :span="1"><span class="dot"></span></el-col>
                <el-col :span="7"><span v-text="item.comment"></span></el-col
              ></el-row>
            </li>
          </ul>
          <div
            v-clickoutside="hideReplyBtn"
            @click="inputFocus"
            class="my-reply"
          >
            <div
              class="reply-info"
              style="position: absolute; left: 0px; z-index: 10"
            >
              <div
                tabindex="1"
                contenteditable="true"
                id="replyInput"
                spellcheck="false"
                placeholder="输入评论..."
                class="reply-input"
                @focus="showReplyBtn"
                @input="onDivInput($event)"
              ></div>
              <br />
              <el-col class="reply-btn-box" v-show="btnShow">
                <el-button
                  class="reply-btn"
                  size="mini"
                  @click="sendComment"
                  type="primary"
                >
                  发表评论
                </el-button>
              </el-col>
            </div>
          </div>
          <el-dialog
            title="问与答"
            :visible.sync="qAndADialogVisible"
            width="40%"
          >
            <el-avatar
              class="header-img"
              :size="40"
              :src="authorHeadImg"
            ></el-avatar>
            <div class="author-info">
              <span class="author-name">{{ authorName }}</span>
              <span class="author-time">{{ authorTime }}</span>
            </div>
            <div class="icon-btn">
              <span @click="showReplyInput('0', authorName, authorId)">
                <i class="iconfont el-icon-s-comment"></i>
                {{ commentNum }}
              </span>

              <span class="xin" @click="countlikeNumber('1', authorId)">
                <i class="iconfont el-icon-caret-top" v-if="isLike">&#xe607;</i>
                <i class="iconfont el-icon-caret-top" v-else>&#xe68b;</i>
                {{ like }}
              </span>
            </div>
            <div class="talk-box">
              <p>
                <span class="reply">{{ question }}</span>
              </p>
            </div>
            <div class="reply-box">
              <div
                v-for="(reply, j) in this.reply"
                :key="j"
                class="author-title"
              >
                <el-avatar
                  class="header-img"
                  :size="40"
                  :src="reply.fromHeadImg"
                ></el-avatar>
                <div class="author-info">
                  <span class="author-name">{{ reply.from }}</span>
                  <span class="author-time">{{ reply.time }}</span>
                </div>
                <div class="icon-btn">
                  <span @click="showReplyInput(j, reply.from, reply.id)">
                    <i class="iconfont el-icon-s-comment"></i>
                    {{ reply.commentNum }}
                  </span>
                  <span @click="countlikeNumber('2', j, reply)">
                    <i class="iconfont el-icon-caret-top"></i>
                    {{ reply.like }}
                  </span>
                </div>
                <div class="talk-box">
                  <p>
                    <span>回复 {{ reply.to }}:</span>
                    <span class="reply">{{ reply.comment }}</span>
                  </p>
                </div>
                <div class="reply-box"></div>
              </div>
            </div>
            <div v-show="_inputShow()" class="my-reply my-comment-reply">
              <el-avatar
                class="header-img"
                :size="40"
                :src="myHeader"
              ></el-avatar>
              <div class="reply-info">
                <div
                  tabindex="0"
                  contenteditable="true"
                  spellcheck="false"
                  placeholder="输入评论..."
                  @input="onDivInput($event)"
                  class="reply-input reply-comment-input"
                ></div>
              </div>
              <div class="reply-btn-box">
                <el-button
                  class="reply-btn"
                  size="mini"
                  @click="sendCommentReply()"
                  type="primary"
                >
                  发表回复
                </el-button>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="qAndADialogVisible = false"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>
<script>
const clickoutside = {
  // 初始化指令
  bind (el, binding, vnode) {
    function documentHandler (e) {
      // 这里判断点击的元素是否是本身，是本身，则返回
      if (el.contains(e.target)) {
        return false
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
        binding.value(e)
      }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.vueClickOutside = documentHandler
    document.addEventListener('click', documentHandler)
  },
  update () {},
  unbind (el, binding) {
    // 解除事件监听
    document.removeEventListener('click', el.vueClickOutside)
    delete el.vueClickOutside
  }
}

module.exports = {
  name: 'CoverComponent',
  data () {
    return {
      url: '../../static/materials/cover.jpg',
      qAndADialogVisible: false,
      question: '',

      authorHeadImg: '',
      authorName: '',
      authorTime: '',
      commentNum: 0,
      authorId: '',
      isLike: false,
      like: 0,
      authorComment: '',
      reply: [],

      btnShow: false,
      index: '0',
      replyComment: '',
      subIndex: '0',
      myName: '石老师',
      myHeader:
        '../../static/materials/user.gif',
      myId: 19870621,
      to: '',
      toId: -1,
      comments: [
        {
          name: '热心学者1',
          id: 19870621,
          headImg:
            '../../static/materials/user.gif',
          comment:
            '石老师，我最近在读布拉格语言学流派的一本书，里面有句话，“音系学是语言学的组成部分，而语音学只是语言学的一门辅助学科，它事实上是一门自然科学”，为什么语音学是自然科学？您可以帮忙解释下吗？',
          time: '2022年9月6日 18:43',
          commentNum: 2,
          like: 15,
          isLike: false,
          likeListId: [], // 存放已点赞用户的id
          inputShow: false,
          reply: [
            {
              from: '石老师',
              fromId: 19891221,
              fromHeadImg:
                '../../static/materials/user.gif',
              to: 'Lana Del Rey',
              toId: 19870621,
              comment:
                '我本来是不同意布拉格学派的这种观点。他们所讲的“语音学是自然科学”，应该指的是语音学的实验方法和研究对象的物理性质。实际上，语音学和音系学是不能分开的。因为人类的语音都是成系统的，所以只要研究语音，不可能脱离语音的系统。游离于系统之外的语音是不存在的。人类语言就是有声语言。语音不仅是自成系统，而且还负载着语言各个子系统的内容。如果语言是信息的载体，语音就是语言的载体。语音学是语言学的一门基础学科。',
              time: '2022年9月16日 18:43',
              commentNum: 1,
              like: 15,
              isLike: false,
              likeListId: [],
              inputShow: false
            }
          ]
        },
        {
          name: '热心学者2',
          id: 19891221,
          headImg:
            '../../static/materials/user.gif',
          comment:
            '如何把两个声调看成是一个？如果根据T值来算，两个声调各个点之间的值相差多少，可以看成一个调？',
          time: '2022年9月16日 18:43',
          commentNum: 1,
          like: 5,
          likeListId: [],
          inputShow: false,
          reply: [
            {
              from: '石老师',
              fromId: 19870621,
              fromHeadImg:
                '../../static/materials/user.gif',
              to: '热心学者2',
              toId: 19891221,
              comment:
                '你提的问题很有意义。两个声调接近到什么程度，可以判定为已经合并为同一个声调。当然问题还可以反过来考虑：一个声调的两个变体相差到什么程度，可以判定为已经分化为两个声调。可以分为两个方面来考虑。一个是调层，一个是调型。在调型相同的情况下，例如，同是平调，或同是降调，二者高度相差多少会听为不同的声调。两个调型不同的声调，如一个平调一个降调，或一个升调一个降调，二者起点或终点相差到什么程度会听为不同的声调。我在“试论普通话声调的本调”（2020）文章中已经涉及这个问题。只是没有专门讨论。声调的分合问题不能只从声学实验中解决，而是要用听感测试来解决。而且具体的情况会比较复杂。首先是作为测试对象的语言中要实际存在这样两个声调的调位对立，才能测试二者的听感边界。而且这听感边界还会受到不同因素的影响而发生动态变化。如：调阶对立跟调型对立表现不一样，在单音和连音时不一样，连音时在前字和在后字又不一样，而且不论连音在前字和在后字，邻接不同的声调时也会不一样，等等。',
              time: '2022年9月16日 18:43',
              commentNum: 25,
              like: 5,
              isLike: false,
              likeListId: [],
              inputShow: false
            }
          ]
        },
        {
          name: '热心学者3',
          id: 20190830,
          headImg:
            '../../static/materials/user.gif',
          comment:
            '我有个疑问：语调属于句法功能范畴吗？如果不是，那属于句法的什么范畴？可能表达不太好。我的意思是语调有句法功能吗？如果有，能举个例子吗？拜谢！',
          time: '2022年9月5日 18:43',
          commentNum: 0,
          like: 5,
          isLike: false,
          likeListId: [],
          inputShow: false,
          reply: [
            {
              from: '石老师',
              fromId: 19870621,
              fromHeadImg:
                '../../static/materials/user.gif',
              to: '热心学者4',
              toId: 19891221,
              comment:
                '语调是组成句子的必有成分，当然具有句法功能。请参阅《语调格局一实验语言学的奠基石》(商务2013)和《韵律格局一语音跟语义、语法、语用的结合》(商务2020)。',
              time: '2022年9月5日 18:43',
              commentNum: 25,
              like: 5,
              isLike: false,
              likeListId: [],
              inputShow: false
            }
          ]
        }
      ]
    }
  },
  computed: {},
  directives: { clickoutside },
  methods: {
    qAndAClick (item) {
      this.qAndADialogVisible = true
      this.question = item.comment
      this.authorId = item.id
      this.authorHeadImg = item.headImg
      this.authorName = item.name
      this.commentNum = item.commentNum
      this.authorTime = item.time
      this.isLike = item.isLike
      this.like = item.like
      this.reply = item.reply
    },
    inputFocus () {
      var replyInput = document.getElementById('replyInput')
      replyInput.style.padding = '8px 8px'
      replyInput.style.border = '2px solid #004947'
      replyInput.focus()
    },
    showReplyBtn () {
      this.btnShow = true
    },
    hideReplyBtn () {
      this.btnShow = false
      replyInput.style.padding = '10px'
      replyInput.style.border = 'none'
    },
    showReplyInput (j, name, id) {
      this.comments.inputShow = false
      this.comments.inputShow = true
      this.to = name
      this.toId = id
      this.subIndex = j == '0' ? '0' : j
    },

    countlikeNumber (type, j, id) {
      const text = type === '1' ? this.comments : this.comments.reply[j]
      let list = text.likeListId
      if (list.length === 0) {
        // 在已经点赞的列表中未找到userId
        text.isLike = true
        text.like += 1
        text.likeListId.push(id)
        console.log('点赞+1', text.isLike, text.like, text.likeListId)
      } else {
        const index = list.indexOf(this.myId)
        text.isLike = false
        text.like -= 1
        text.likeListId.splice(index, 1)
        console.log('点赞-1', text.isLike, text.likeListId)
      }
    },
    _inputShow () {
      return this.comments.inputShow
    },
    sendComment () {
      if (!this.replyComment) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '评论不能为空'
        })
      } else {
        let a = {}
        let input = document.getElementById('replyInput')
        let timeNow = new Date().getTime()
        let time = this.dateStr(timeNow)
        a.name = this.myName
        a.comment = this.replyComment
        a.headImg = this.myHeader
        a.time = time
        a.commentNum = 0
        a.like = 0
        a.id = this.myId
        a.reply = []
        a.isLike = false
        a.likeListId = []
        this.comments.push(a)
        this.replyComment = ''
        input.innerHTML = ''
      }
    },
    sendCommentReply () {
      if (!this.replyComment) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '回复不能为空'
        })
      } else {
        let a = {}
        let timeNow = new Date().getTime()
        let time = this.dateStr(timeNow)
        a.from = this.myName
        a.to = this.to
        a.fromHeadImg = this.myHeader
        a.comment = this.replyComment
        a.time = time
        a.commentNum = 0
        a.like = 0
        a.isLike = false
        a.likeListId = []
        console.log(
          ' this.comments.reply+++++++++++',
          this.comments.reply,
          this.subIndex
        )
        if (this.subIndex === '0') {
          this.comments.commentNum += 1
        } else {
          this.comments.reply[this.subIndex].commentNum += 1
        }
        this.comments.reply.push(a)
        this.replyComment = ''
        document.getElementsByClassName('reply-comment-input')[i].innerHTML =
          ''
      }
    },
    onDivInput: function (e) {
      this.replyComment = e.target.innerHTML
    },
    dateStr (date) {
      // 获取js 时间戳
      var time = new Date().getTime()
      // 去掉 js 时间戳后三位，与php 时间戳保持一致
      time = parseInt((time - date) / 1000)
      // 存储转换值
      var s
      if (time < 60 * 10) {
        // 十分钟内
        return '刚刚'
      } else if (time < 60 * 60 && time >= 60 * 10) {
        // 超过十分钟少于1小时
        s = Math.floor(time / 60)
        return s + '分钟前'
      } else if (time < 60 * 60 * 24 && time >= 60 * 60) {
        // 超过1小时少于24小时
        s = Math.floor(time / 60 / 60)
        return s + '小时前'
      } else if (time < 60 * 60 * 24 * 30 && time >= 60 * 60 * 24) {
        // 超过1天少于30天内
        s = Math.floor(time / 60 / 60 / 24)
        return s + '天前'
      } else {
        // 超过30天ddd
        var date = new Date(parseInt(date))
        return (
          date.getFullYear() +
          '/' +
          (date.getMonth() + 1) +
          '/' +
          date.getDate()
        )
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/**左边最大框 */
.cover_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  /* padding: 0 !important; */
  background-color: white;
}
.cover {
  text-align: left;
  border: 1px solid #b3c0d1;
  border-radius: 6px;
  overflow: hidden;
}
.img_cover {
  margin: 5px 0px 10px 10px;
  height: 420px;
  overflow: hidden;
  /* background-color: red; */
  width: 360px;
}
.introduction_pre {
  font-weight: 900;
  font-size: 16px;
}

.introduction_back {
  font-weight: 100;
  font-size: 16px;
}

.introduction_detail {
  margin-left: 10px;
  font-weight: bold;
  text-align: left;
  margin-top: 10px;
}
.q_and_a_pre {
  margin-top: 10px;
  border-radius: 10px;
  border: 1px solid #b3c0d1;
  margin-bottom: 10px;
  text-align: left;
  overflow: hidden;
  height: 410px;
}

.q_and_a {
  background-image: linear-gradient(#006a71, #005152, #002412);
  height: 30px;
  color: aliceblue;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
  border-radius: 5px;
  padding-left: 10px;
  font-weight: 900;
  margin-top: 10px;
  margin-left: 10px;
}

.q_and_a_detail {
  text-align: left;
  margin-left: 10px;
  font-size: 14px;
  overflow: auto;
  height: 410px;

}
li {
  list-style-type: none;
}
.exceed {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: clip; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
  margin-top: 10px !important;
  padding-left: 10px !important;
  margin-bottom: 10px !important;
  text-align: left;
}
.space {
  margin-bottom: 10px;
  color: #006a71;
}
.dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #006a71;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  text-align: left;
}

.my-reply {
  padding: 10px;
  background-color: #fafbfc;
  .header-img {
    display: inline-block;
    vertical-align: top;
  }
  .reply-info {
    display: inline-block;
    margin-left: 5px;
    width: 100%;
    //根据屏幕宽度自适应

    .reply-input {
      min-height: 20px;
      line-height: 22px;
      padding: 10px 10px;
      color: black;
      background-color: #fff;
      border-radius: 5px;
      // &:empty::before{
      //   content attr(placeholder);
      // }
      &:empty:before {
        content: attr(placeholder);
      }
      &:focus:before {
        content: none;
      }
      &:focus {
        padding: 8px 8px;
        border: 2px solid #004947;
        box-shadow: none;
        outline: none;
      }
    }
  }
  .reply-btn-box {
    height: 25px;
    // margin: 10px 0;
    display: inline-block;
    .reply-btn {
      position: relative;
      float: right;
      margin-left: 15px;
      // margin-right: 15px;
    }
  }
}
.my-comment-reply {
  margin-left: 50px;

  .reply-input {
    width: flex;
  }
}
.author-title:not(:last-child) {
  border-bottom: 1px solid rgba(74, 136, 199, 0.3);
}
.reply-father {
  padding: 10px;
  .header-img {
    display: inline-block;
    vertical-align: top;
  }
  .author-info {
    display: inline-block;
    margin-left: 5px;
    width: 60%;
    height: 40px;
    line-height: 20px;
    span {
      display: block;
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .author-name {
      color: #000;
      font-size: 18px;
      font-weight: bold;
    }
    .author-time {
      font-size: 14px;
    }
  }
  .icon-btn {
    width: 30%;
    padding: 0 !important ;
    float: right;

    span {
      cursor: pointer;
    }
    .iconfont {
      margin: 0 5px;
    }
  }
  .talk-box {
    margin: 0 50px;
    p {
      margin: 0;
    }
    .reply {
      font-size: 16px;
      color: #000;
    }
  }
  .reply-box {
    margin: 10px 0 0 50px;
    background-color: #efefef;
  }
}
.el-button--primary {
  //需要更改的按钮类型 type='primary'
  background: #004947 !important;
  border-color: #004947 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/coverComponent.vue